const urlName = '/usercenter/v2/t-c/branch'
export default (API) => ({
	findMyBranch() {
		return API({
			url: `${urlName}/findMyBranch`,
		})
	},
})
